/** A new slip. Nothing is written -- and no number is spent -- until the first Post. */
import { DRYING_SLIP_FORM } from "@nexseed/shared";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { FormPageSkeleton } from "@/components/app/skeletons";
import { useAuth } from "@/features/auth/store";
import { useFacilities } from "@/features/auth/use-facilities";
import { DryingSlipPage } from "@/features/processing/components/drying-slip-page";

export const Route = createFileRoute("/_app/processing/drying/new")({
  beforeLoad: () => {
    if (!useAuth.getState().canCreateForm(DRYING_SLIP_FORM))
      throw redirect({ to: "/processing/drying" });
  },
  component: Page,
});

function Page() {
  const { selected, ready } = useFacilities();
  if (!ready) return <FormPageSkeleton />;
  return (
    <DryingSlipPage
      slip={null}
      facilityId={selected?.id}
      plantName={selected ? `${selected.name} (${selected.plantCode})` : null}
    />
  );
}
